var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDashedLine = function SvgDashedLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 274,
    height: 2,
    viewBox: "0 0 274 2",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1h272",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "10 8"
  })));
};
export { SvgDashedLine as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNzQiIGhlaWdodD0iMiIgdmlld0JveD0iMCAwIDI3NCAyIiBmaWxsPSJub25lIj4KICA8cGF0aCBkPSJNMSAxSDI3MyIgc3Ryb2tlPSIjNzU3NTc1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS1kYXNoYXJyYXk9IjEwIDgiLz4KPC9zdmc+";